/*
 * Two fixes around personalised products, neither of which the Infinite
 * Options "Native Bundling" setting covers.
 *
 * PART 1 keeps add-to-cart on the AJAX path. Infinite Options calls
 * form.submit() on the product form, and Shopify answers a native form post
 * to /cart/add with a redirect to /cart, which is why the cart drawer never
 * opened.
 *
 * PART 2 removes the cart line that was actually clicked. The theme's own
 * cart.updateItem matches lines loosely enough that removing one can take
 * out others. See the comment above that listener.
 *
 * An earlier version of this file also kept the £10 fee's own cart line in
 * step with its product, and the Liquid hid that line's controls. Native
 * bundling merges the fee into the product line, so there is nothing left to
 * keep in step and both have been removed.
 */
(function () {
  'use strict';

  var nativeSubmit = HTMLFormElement.prototype.submit;
  var nativeFetch = window.fetch;

  function isAddToCartForm(form) {
    var action = (form.getAttribute('action') || '').split('?')[0].replace(/\/$/, '');
    return action.slice(-9) === '/cart/add';
  }

  function setLineQuantity(key, quantity) {
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  // The theme refreshes the drawer and opens it on this event.
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
  }

  /*
   * PART 1.
   *
   * Scoped to product forms by action. Other scripts on the page call
   * form.submit() too, the Facebook pixel among them, and those must be
   * left alone.
   */
  HTMLFormElement.prototype.submit = function () {
    var form = this;

    if (!isAddToCartForm(form)) return nativeSubmit.apply(form, arguments);

    nativeFetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add to cart returned ' + response.status);
        return response.json();
      })
      .then(refreshCart)
      .catch(function (error) {
        if (window.console && window.console.warn) {
          window.console.warn('[personalisation-fee] adding over AJAX failed, submitting normally', error);
        }
        nativeSubmit.call(form);
      });
  };

  /*
   * PART 2: remove the line that was actually clicked.
   *
   * The theme's cart.updateItem matches a line like this:
   *
   *   if (item.key === key || item.id === parseInt(key, 10))
   *
   * A line key reads "56476741435771:0ea0b5b9...", and parseInt stops at
   * the colon, so it yields the variant id. Every line sharing that variant
   * therefore matches, and the forEach around it fires a change for each
   * one against shifting line numbers.
   *
   * With a personalised and a plain unit of the same product in the cart,
   * removing one took out both. That is the fault behind the orders that
   * arrived charged for personalisation with no details on them.
   *
   * The row already carries its own key, so we remove by key and let the
   * theme re-render.
   */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest('[data-remove-item]');
      if (!trigger) return;

      var row = trigger.closest('[data-key]');
      var key = row && row.getAttribute('data-key');

      // Only act on a full line key. Anything else is left to the theme.
      if (!key || key.indexOf(':') === -1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      setLineQuantity(key, 0)
        .then(refreshCart)
        .catch(function (error) {
          if (window.console && window.console.warn) {
            window.console.warn('[personalisation-fee] could not remove the line', error);
          }
        });
    },
    true
  );
})();
